if (typeof QuickView === "undefined") {
  const { FoxThemeStyles, FoxThemeScripts } = window;
  class QuickView {
    constructor() {
      this.modal = null;

      addEventDelegate({
        selector: "[data-product-quickview]",
        handler: (e, target) => {
          e.preventDefault();
          this.target = target;
          target.classList.add("btn--loading");
          const productHandle = target.dataset.productQuickview;
          if (productHandle) this.fetchHtml(productHandle);
        },
      });

      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (this.modal) this.modal.hide();
      });
    }

    fetchHtml(productHandle) {
      loadAssets(
        [FoxThemeStyles.product, FoxThemeStyles.volumePricing],
        "quick-view-assets"
      );
      fetchSection("product-quickview", {
        url: `${window.FoxThemeSettings.base_url}products/${productHandle}`,
      })
        .then((html) => {
          this.modal = html.querySelector("modal-dialog");
          const firstModel = html.querySelector("product-model");
          this.mediaGallery = this.modal.querySelector("media-gallery");
          document.body.appendChild(this.modal);
          loadAssets(
            [
              FoxThemeScripts.productInfo,
              FoxThemeScripts.productMedia,
              FoxThemeScripts.variantsPicker,
              FoxThemeScripts.volumePricing,
            ],
            "variants-picker",
            () => {
              this.modal && this.modal.show(this.target);

              /* --- Quick View: enforce min qty for Swatch/Rolls/Yardage (works with quantity-input + data-min-qty-wired) --- */
(() => {
  const modal = this.modal;
  if (!modal) return;

  // elements inside THIS modal
  const qtyInput = () =>
    modal.querySelector('quantity-input input[name="quantity"], input[name="quantity"]');
  const minusBtn = () =>
    modal.querySelector('quantity-input button[name="minus"], .quantity__button[name="minus"]');
  const pickerRoot = () =>
    modal.querySelector('.product-single__block--variant_picker') || modal;

  // detect Fabric vs Wallpaper from the handle that’s in your DOM
  const productKind = () => {
    const h = (modal.querySelector('[data-product-handle]')?.dataset?.productHandle || '').toLowerCase();
    if (h.includes('fabric')) return 'fabric';
    if (h.includes('wallpaper')) return 'wallpaper';
    // fallback to visible text
    const t = (modal.textContent || '').toLowerCase();
    if (t.includes('fabric')) return 'fabric';
    if (t.includes('wallpaper')) return 'wallpaper';
    return '';
  };

  // read the current type label (Swatch / Rolls / Yardage)
  const currentTypeLabel = () => {
    // selected pill/button
    const btn = pickerRoot().querySelector(
      '[aria-pressed="true"], [aria-selected="true"], .is-selected, .active, .current'
    );
    if (btn) return (btn.textContent || btn.value || '').trim();

    // checked radio
    const r = pickerRoot().querySelector('input[type="radio"]:checked');
    if (r) return (r.value || '').trim();

    // selected option
    const s = pickerRoot().querySelector('select');
    if (s) return (s.value || s.selectedOptions?.[0]?.text || '').trim();

    // inline "Type: X"
    const node = Array.from(modal.querySelectorAll('*')).find(el => /type\s*:\s*/i.test(el.textContent || ''));
    if (node) {
      const m = (node.textContent || '').match(/type\s*:\s*([A-Za-z]+)/i);
      if (m && m[1]) return m[1].trim();
    }
    return '';
  };

  const computeMin = (kind, label, nativeMinAttr) => {
    const nativeMin = Number(nativeMinAttr || 0);
    const L = (label || '').toLowerCase();
    let min = 1;
    if (kind === 'wallpaper') min = L.includes('rolls') ? 2 : 1;   // Swatch=1, Rolls=2
    if (kind === 'fabric')   min = L.includes('yardage') ? 5 : 1;    // Swatch=1, Yardage=5
    return nativeMin > min ? nativeMin : min; // respect Shopify Purchase limits if higher
  };

  function applyMin() {
    const q = qtyInput();
    if (!q) return;

    const kind = productKind();
    const label = currentTypeLabel();
    const newMin = computeMin(kind, label, q.getAttribute('min'));

    // 1) set input min and snap value up if needed
    q.min = newMin;
    if (!q.value || Number(q.value) < newMin) q.value = newMin;

    // 2) update the theme’s guard on the minus button
    const minus = minusBtn();
    if (minus) minus.setAttribute('data-min-qty-wired', String(newMin));

    // Optional debug:
     console.log('[QV:min]', { kind, label, newMin, value: q.value });
  }

  // Run now + after small delays (covers hydration)
  applyMin();
  setTimeout(applyMin, 60);
  setTimeout(applyMin, 250);

  // Re-apply when variant/type changes
  const form = modal.querySelector('product-form form, form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('change', e => {
      if (e.target && (e.target.matches('input[type="radio"]') || e.target.matches('select'))) {
        applyMin();
      }
    });
  }

  // Re-apply when a type pill button is clicked
  pickerRoot().addEventListener('click', e => {
    const btn = e.target.closest('button, [role="button"]');
    if (!btn) return;
    if (/(swatch|roll|yard)/i.test((btn.textContent || btn.value || '').trim())) {
      setTimeout(applyMin, 0); 
    }
  });

  // Re-apply after any DOM swap inside the modal (your theme re-renders the section)
  const mo = new MutationObserver(() => applyMin());
  mo.observe(modal, { childList: true, subtree: true });
  modal.addEventListener('close', () => mo.disconnect(), { once: true });
})();

              document.dispatchEvent(
                new CustomEvent("quick-view:open", {
                  detail: { productUrl: `/products/${productHandle}` },
                })
              );
              if (this.mediaGallery) {
                const thumb = this.mediaGallery.querySelector(
                  '[id^="GalleryThumbnails"]'
                );
                if (thumb) thumb.update();
                this.mediaGallery.update();
              }
              if (Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
              this.target.classList.remove("btn--loading");
              this.handleClose();
              this.toolTip = __reInitTooltip(this.modal);

              document.dispatchEvent(
                new CustomEvent("quick-view:loaded", {
                  detail: { productUrl: `/products/${productHandle}` },
                })
              );
            }
          );
          if (firstModel) {
            loadAssets(
              [
                FoxThemeScripts.productModel,
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
              ],
              "product-model-assets"
            );
          }
        })
        .catch(console.error);
    }

    handleClose() {
      if (!this.modal) return;
      this.modal.addEventListener("close", () => {
        const allTooltip = [
          ...(this.modal.querySelector("product-info")?.toolTip || []),
          ...(this.toolTip || []),
        ];
        allTooltip.forEach((item) => item.unmount());

        const quantityInputs = this.modal.querySelectorAll("quantity-input");
        quantityInputs.forEach((input) => {
          input.disconnectedCallback();
        });

        this.modal.remove();
      });
    }
  }
  new QuickView();
  window.QuickView = QuickView;
}

